export const TherapiesContext = [
  'Acupuncture',
  'Bach Remedies',
  'Biomat Therapy',
  'Caster Oil Packing',
  'Chiropractic',
  'Cranial Therapy',
  'Cryotherapy',
  'Deep Breathing',
  'Dietary Changes',
  'Emotional Therapy',
  'Epsom Salt Float Tank',
  'Essential Oils',
  'Exercise Regimen',
  'FIR Sauna',
  'Hocatt Therapy',
  'Hydrogen Peroxide Therapy',
  'Hydrogen Baths',
  'Hydrogen Inhalation',
  'Hydrogen Water',
  'Hyperbarics',
  'Infrared Sauna',
  'ION Footbath Detox',
  'IV Therapy',
  'Laser Therapy',
  'Lymph Flowpresso',
  'Lymph Rebounding',
  'Lymph Vibration Plate',
  'Massage Therapy',
  'Ozone Therapy',
  'PEMF',
  'Photonic Mat',
  'Prayer/Meditation',
  'Red Light Therapy',
  'Reflexology',
  'Rife Frequency',
  'Sauna',
  'Spiritual',
  'Supplementation',
  'Sunlight',
  'Ultra Violet Therapy'
];